import { cn } from '@savvy-kit/lib/utils';

export type DataTableToolbarBottomProps = {
  className?: string;
  children?: React.ReactNode;
};

export function DataTableToolbarBottom({ className, children }: DataTableToolbarBottomProps) {
  return <div className={cn('flex items-center justify-between px-4 py-3', className)}>{children}</div>;
}
